import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([
  {
    flexGrow: '1',
    width: '100%'
  }
]);

const DisplayFlex = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-flex');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} />;
}
export default DisplayFlex;